// Returns the non-default LC names that apply to a worker for tooltip display.
// Mirrors the read rule used across the app:
//   - if worker has individual hours, override = each hours[].laborClassificationId
//     that is set AND different from sheet.defaultLaborClassificationId;
//   - else override = worker.laborClassificationId if set AND not default;
//   - names that don't resolve to a known LC in store are dropped.
export const getWorkerLcOverrideNames = (worker, sheet, lcById) => {
  if (!worker || !sheet) return [];
  const defaultId = sheet.defaultLaborClassificationId || null;
  const hasHours = Array.isArray(worker.hours) && worker.hours.length > 0;

  if (hasHours) {
    return worker.hours
      .map((h) => h?.laborClassificationId)
      .filter((id) => id && id !== defaultId)
      .map((id) => lcById?.[id]?.name)
      .filter(Boolean);
  }

  const workerLcId = worker.laborClassificationId;

  if (workerLcId && workerLcId !== defaultId) {
    const name = lcById?.[workerLcId]?.name;
    if (name) return [name];
  }
  return [];
};

export const stripLcFromProject = (project, lcId) => {
  if (!project || !lcId) return project;
  const wasDefault = project.defaultLaborClassificationId === lcId;
  const alternates = project.alternateLaborClassifications || [];
  const wasAlternate = alternates.includes(lcId);
  if (!wasDefault && !wasAlternate) return project;
  return {
    ...project,
    defaultLaborClassificationId: wasDefault ? null : project.defaultLaborClassificationId,
    alternateLaborClassifications: wasAlternate
      ? alternates.filter((id) => id !== lcId)
      : alternates,
  };
};
